/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-unused-vars */
import images from 'assets/images/images'
//import IncDecrement from 'components/IncDecrement'
import Button from 'components/form-elements/buttons/Button'
import { useRequest } from 'hooks/useRequest'
import useTranslate from 'hooks/useTranslate'
import LoaderTwo from 'pages/LoaderTwo'
import React, { useEffect, useRef, useState } from 'react'
import {BiMinus, BiPlus} from 'react-icons/bi'
import { GrClose } from 'react-icons/gr'
import { MdModeEditOutline } from 'react-icons/md'
import { RiDeleteBin6Line } from 'react-icons/ri'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { getAllBasketFunc } from 'redux/features/general/generalSlice'
import auth from 'utils/Auth'
import CurrencyFormatter from 'utils/CurrencyFormatter'
import { dataLayerPush } from 'utils/Datalayer'

const AddBasketDrawerStageTwo = ({isOpenDrawer,setSingleDrawerProduct,getAllBasket,setIsOpenDrawer,setProductStage, setProductCount, setApprovalModal}) => {
  const dispatch = useDispatch();
  const [request, loading] = useRequest();
  const navigate = useNavigate();
  const [openEdit, setOpenEdit] = useState({open: false, id: null})
  const [suggestedProducts, setSuggestedProducts] = useState([])
  const drRef = useRef(null)
  const {t} = useTranslate()
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (drRef.current && !drRef.current.contains(event.target)) {
        setOpenEdit({open: false, id: null})
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [drRef]);
  useEffect(()=> {
    request('/ShoppingCart/SuggestedProducts', {
      method: 'GET',
      headers: {
        restaurantId: auth.getUserChoises()?.restaurantId,
        deliveryType: auth.getUserChoises()?.deliveryType,
        neighbourhoodId: auth.getUserChoises()?.neighbourhoodId,
        regionId: auth.getUserChoises()?.regionId,
      }
    }).then((res) => {
      if (res) {
        setSuggestedProducts(res?.data?.result.map(p => ({...p,quantity:1})))
      }
    })
  },[])

const newProductCountFunc = (type, order) => {
  if (order?.quantity  > 1 || type != "decrement") {
    const newData = {
      "productId": order?.productId,
      "quantity": type == 'increment' ?  1 :  -1 ,
      "attributes": [
          ...order.attributes.map((ord) => (
              {             
                  //"productId": 8,
                  "productAttributeId": ord.productAttributeId,
                  "value": ord.value
              }
          ))
          ]  
       }
      request('/ShoppingCart/UpdateCart', { 
          method: 'POST',
          data: newData,
          headers: {
            restaurantId: auth.getUserChoises()?.restaurantId,
            deliveryType: auth.getUserChoises()?.deliveryType,
            neighbourhoodId: auth.getUserChoises()?.neighbourhoodId,
            regionId: auth.getUserChoises()?.regionId,
  
          }
        }).then((res) => {
            if(res.data){
              dispatch(getAllBasketFunc(res?.data?.result))
              toast.success(t('successfullToast',{type:t('update'),name:''}))
            }
        })
  }
}

const addBasketSuggestedProduct = (product) => {
  let newQuantity =  suggestedProducts.find(suggest => suggest.id == product.id)?.quantity
  //const productSet = [product].map(prev => ({...prev, quantity: newQuantity}))
   setSingleDrawerProduct({id: product?.id, item: product})
   setProductCount(newQuantity)
   setIsOpenDrawer(true)
   setProductStage(1)
  // request('/ShoppingCart/UpdateCart', {
  //   method: 'POST',
  //   data: {
  //     productId:product.id,
  //     quantity:product.quantity,
  //     attributes:[]
  //   },
  //   headers: {
  //     restaurantId: auth.getUserChoises()?.restaurantId,
  //     deliveryType: auth.getUserChoises()?.deliveryType,
  //     neighbourhoodId: auth.getUserChoises()?.neighbourhoodId,
  //     regionId: auth.getUserChoises()?.regionId,
  //   }
  // }).then((res) => {
  //   if(res.data){
  //       toast.success('Ürün Sepete Eklendi')
  //       dispatch(getAllBasketFunc(res?.data?.result))
  //   }
  // })


}
const closeAddBasketDrawerStageTwo = () => {
  setProductStage(1)
  setIsOpenDrawer(false)
}  

const openDropdownMenu = (id) => {
  setOpenEdit({open: !openEdit.open, id: id})
}



const updateItem = (product) => {
   setSingleDrawerProduct({id: product?.productId, item: product})
   setProductCount(product?.quantity)
   setIsOpenDrawer(true)
   setProductStage(1)
}

  const deleteAllBasket = () => {
    if( getAllBasket?.items?.length > 0){
      setApprovalModal({open:true,type:'CLEAR'})
    }
  }

  useEffect(() => {
     if(!isOpenDrawer){
      setProductStage(1)
     }
  },[isOpenDrawer])


  return (
    <div className='addBasketDrawerStageTwo'>
       <LoaderTwo isDataLoading={loading} />
      <div onClick={closeAddBasketDrawerStageTwo} className='addBasketDrawerStageTwo-close'>
            <GrClose size={30}/>
        </div>
        <div className='addBasketDrawerStageTwo-text'>
            <div className='addBasketDrawerStageTwo-text-title'>{auth?.getUserChoises()?.deliveryType == 2 && t('cometoMyAddress')}{auth?.getUserChoises()?.deliveryType == 1 && t('buyFromBranch')}</div>
            <div className='addBasketDrawerStageTwo-text-description'>{auth?.getUserChoises()?.restaurantName}</div>
        </div>
        <div onClick={deleteAllBasket} className='addBasketDrawerStageTwo-clearBasket'>
          {t('clearBasketBtn')}
        </div>
        <div className='addBasketDrawerStageTwo-basket'>
             {
              getAllBasket?.items?.map((order,i) => (
                <div className='addBasketDrawerStageTwo-basket-container' key={i}>
                  <div className='addBasketDrawerStageTwo-basket-container-top'>
                  <div className='addBasketDrawerStageTwo-basket-container-top-left'>
                  {/* <IncDecrement setProductCount={setProductCount} productCount={productCount}/> */}
                       {
                        order?.productName && (
                          <div className='incdecrement sm'>
                          <BiMinus onClick={()=>newProductCountFunc('decrement',order)} size={16}/>  
                          <div className='body-m'>{order?.quantity || 1}</div>
                          <BiPlus onClick={()=>newProductCountFunc('increment',order)} size={16}/>
                        </div>
                        )
                       }
                     
                    <div className='addBasketDrawerStageTwo-basket-container-top-left-text'>
                        <div className='addBasketDrawerStageTwo-basket-container-top-left-text-title'>{order?.productName}</div>  
                        <div className='addBasketDrawerStageTwo-basket-container-top-left-text-description '>{order?.unitPrice ? order?.unitPrice.toFixed(2) + " TL" : ""}</div> 
                        {
                          order?.warnings?.length > 0 && <div className='body-xs text-danger'>({order?.warnings?.join(', ')})</div>
                        } 
                    </div>
                  </div>
                   <div className='addBasketDrawerStageTwo-basket-container-top-right'>
                      <img src={order?.pictureUrl} alt="" />
                      <div className='addBasketDrawerStageTwo-basket-container-top-right-menu'>
                      <img onClick={() => openDropdownMenu(order?.id)} src={images.add2} alt="" />
                       {(openEdit?.open && openEdit?.id == order?.id) &&
                          <div ref={drRef} className='addBasketDrawerStageTwo-basket-container-top-right-menu-item'>
                              <div onClick={() => updateItem(order)}><MdModeEditOutline size={30} color='#96004B'/> {t('updateBtn')}</div>
                              <div onClick={() => setApprovalModal({open:true,order:order,type:'DELETE'})}><RiDeleteBin6Line size={25}/> {t('removeBtn')}</div>
                          </div>
                          } 
                      </div>
                   </div>
                  </div>
                  <div className='addBasketDrawerStageTwo-basket-extraProducts'>
                    {
                    order?.attributes?.map((or) => or?.valueName).join(', ')
                    }
                  </div>
                 
                </div>
              ))
              
             }
              {
                !getAllBasket?.items && (
                  <div className='emptyBasket'>
                     {t('yourCartEmpty')}
                  </div>
                )
                } 
        </div>
        {
         getAllBasket?.bagPrice != 0 && getAllBasket?.bagPrice != null && <>
          <div className='addBasketDrawerStageTwo-descriptionColor'>
          {t('bagAmount')}:  <CurrencyFormatter locale="tr" currency="TRY" value={getAllBasket?.bagPrice} /> {" "}
          </div>
          <div>
          {
          getAllBasket?.bagUsage?.map((bag,i) => (
            <div className='addBasketDrawerStageTwo-descriptionColorSm' key={i}>
              - {bag.productName}: {bag.quantity} {t('piece')}
            </div>
          ))
          }
          </div>
          </>
        }
        <Button onClick={closeAddBasketDrawerStageTwo} className={"grayRoundedBtn"} icon={""} text={t('continueShopping')}/>
        <Button onClick={() => {
           const getPostArray = (orderResult) => {
            const mappedArray = orderResult?.attributes?.length > 0 ? orderResult?.attributes?.map(attribute => {
              return {
                affilication: "Tavuk Dünyası",
                item_brand: "Tavuk Dünyası",
                item_list_name: "Listeleme Sayfası",
                quantity: 1,
                item_variant: 'Ek Ürün',
                item_id: attribute?.productAttributeId,
                price: attribute?.price || 0,
                discount: 0,
                item_category: attribute?.name,
                item_name: attribute?.valueName,
        
              }
            }) : []
            return mappedArray
          }
           const postArray = getAllBasket?.items?.map((item) => {
            if(item?.attributes?.length > 0){
              return [
              ...[{
                  item_name: item?.productName,
                  affilication: "Tavuk Dünyası",
                  discount: item?.discountAmount,
							    item_variant:'Ana Ürün',
                  index: 0,
                  item_brand: "Tavuk Dünyası",
                  item_list_name: "Listeleme Sayfası",
                  price: item?.unitPrice,
                  quantity: item?.quantity,
                  item_id: item?.productId,
                  item_category: item?.categories?.[0]?.value,
                  item_category2: item?.categories?.[1]?.value ? item?.categories?.[1]?.value : "",
                  item_category3: item?.categories?.[2]?.value ? item?.categories?.[2]?.value: "",
              }],
                ...getPostArray(item)
              ]
            }
            return [ {
              item_name: item?.productName,
              affilication: "Tavuk Dünyası",
              discount: item?.discountAmount,
							item_variant:'Ana Ürün',
              index: 0,
              item_brand: "Tavuk Dünyası",
              item_list_name: "Listeleme Sayfası",
              price: item?.price,
              quantity: item?.quantity,
              item_id: item?.productId,
              item_category: item?.categories?.[0]?.value,
              item_category2: item?.categories?.[1]?.value ? item?.categories?.[1]?.value : "",
              item_category3: item?.categories?.[2]?.value ? item?.categories?.[2]?.value: "",
          }]
          })
          const mergedArray = [].concat(...postArray);
          dataLayerPush({ ecommerce: null });
          dataLayerPush({
            event:"begin_checkout",
            ecommerce: {
            item_list_name: "Listeleme Sayfası",
            currency: "TRY",
            value: getAllBasket?.orderTotal,
            items: mergedArray
            }
          })
          navigate('/odeme')}} className={"claretredRoundedBtn"} icon={""} text={t('paymentTotal',{total:getAllBasket?.orderTotal ? getAllBasket?.orderTotal?.toFixed(2) : "00,00"})}/>
       
        {
          getAllBasket?.warnings?.length > 0 && <div className="body-s text-danger text-center">({getAllBasket?.warnings?.join(', ')})</div>
        }
        {
          suggestedProducts.length > 0 && (
            <div className='addBasketDrawerStageTwo-basket'>
              <div className='addBasketDrawerStageTwo-basket-questionText'>{t('wantTry')}</div> 
              <div className='addBasketDrawerStageTwo-basket-container d-flex flex-column gap-3'>
                      {
                        suggestedProducts.map(product => (
                          <div key={product.id} className='addBasketDrawerStageTwo-basket-container-top'>
                          <div className='addBasketDrawerStageTwo-basket-container-top-left'>
                          <div className='incdecrement sm'>
                            <BiMinus onClick={() => setSuggestedProducts(prev => ([...prev.map(p => {
                            if (p.id == product.id && p.quantity >1) {
                              return {...p,quantity:p.quantity - 1}
                            } else {
                              return p
                            }
                          })]))} size={16}/>  
                            <div className='body-m'>{product?.quantity || 1}</div>
                            <BiPlus onClick={() => setSuggestedProducts(prev => ([...prev.map(p => {
                            if (p.id == product.id) {
                              return {...p,quantity:p.quantity +1}
                            } else {
                              return p
                            }
                          })]))} size={16}/>
                          </div>
                            <div className='addBasketDrawerStageTwo-basket-container-top-left-text'>
                                <div className='addBasketDrawerStageTwo-basket-container-top-left-text-title'>{product.name}</div>  
                                <div className='addBasketDrawerStageTwo-basket-container-top-left-text-description'>{product?.price ? product?.price.toFixed(2) + " TL" : ""}</div>  
                            </div>
                          </div>
                          <div className='addBasketDrawerStageTwo-basket-container-top-right'>
                              <img src={product.productImages[0]} alt="" />
                              <img src={images.plus} onClick={() => addBasketSuggestedProduct(product)} alt="" />
                          </div>
                          </div>
                        ))
                      }
                </div>
            </div>
          )
        }
        
    </div>
  )
}

export default AddBasketDrawerStageTwo